<span class="tooltip-icon" (mouseenter)="showTooltip=true" (mouseleave)="showTooltip=false">{{ label }}</span>
@if (showTooltip) {
  <div class="tooltip">
    <p>{{ text }}</p>
  </div>
}
